import React from 'react';
import { MapAnalyticsCharts, RealTimeActivityMonitor, ActivityHeatmap } from '../Analytics';

const MapAnalyticsSection = ({ mapResults, categories, showAnalytics, setShowAnalytics, token }) => {
  if (mapResults.length === 0) return null;

  return (
    <div style={{ marginTop: 25 }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 15
      }}>
        <button
          onClick={() => setShowAnalytics(!showAnalytics)}
          className="btn"
          style={{
            background: showAnalytics
              ? 'linear-gradient(135deg, #FDE047, #FEF08A)'
              : 'rgba(253, 224, 71, 0.2)',
            color: '#0F172A',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            borderRadius: 25,
            border: '2px solid rgba(253, 224, 71, 0.5)',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 600
          }}
        >
          📊 {showAnalytics ? 'Hide' : 'Show'} Advanced Analytics
          <span style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '2px 8px',
            borderRadius: 12,
            fontSize: '0.75rem'
          }}>
            14 Charts
          </span>
        </button>
      </div>

      {showAnalytics && (
        <>
          <MapAnalyticsCharts
            results={mapResults}
            categories={categories}
          />

          {/* Advanced Analytics: Real-Time Activity & Heatmap */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: 20,
            marginTop: 20
          }}>
            <RealTimeActivityMonitor token={token} refreshInterval={5000} />
            <ActivityHeatmap token={token} />
          </div>
        </>
      )}
    </div>
  );
};

export default MapAnalyticsSection;
